(function () {
  function getCurrencyMetaobjects() {
    try {
      return JSON.parse(document.getElementById('currency-metaobjects-json').textContent);
    } catch (e) {
      return [];
    }
  }

  function getHostname(url) {
    try {
      return new URL(url).hostname;
    } catch (e) {
      return '';
    }
  }

  function translate(key, params = {}) {
    let str = window.translations && window.translations[key] ? window.translations[key] : key;
    Object.keys(params).forEach(param => {
      str = str.replace(new RegExp(`{{\\s*${param}\\s*}}`, 'g'), params[param]);
    });
    return str;
  }

  function showCurrencyPopup() {
    // Check if user has previously closed the modal
    if (sessionStorage.getItem('currencyModalClosed') === 'true') {
      return;
    }

    if (document.getElementById('currency-popup-modal')) return;
    const existing = document.getElementById('currency-popup-modal');
    if (existing) existing.remove();

    const modal = document.createElement('modal-dialog');
    modal.id = 'currency-popup-modal';
    modal.className = 'tw-flex tw-items-center tw-justify-center';

    let currencyMetaobjects = [];
    if (document.getElementById('currency-metaobjects-json')) {
      currencyMetaobjects = JSON.parse(document.getElementById('currency-metaobjects-json').textContent);
    }

    let optionsHtml = '';
    currencyMetaobjects.forEach(currency => {
      const isCurrent =
        (currency.is_separate_store && getHostname(currency.store_url) === window.location.hostname) ||
        (!currency.is_separate_store && currency.currency_code === Shopify.currency.active);

      optionsHtml += `
        <option
          value="${currency.currency_code}"
          data-market-id="${currency.market_id}"
          data-separate-store="${currency.is_separate_store}"
          data-store-url="${currency.store_url || ''}"
          ${isCurrent ? 'selected' : ''}>

          ${isCurrent
          ? `${currency.country} (${currency.currency_code})`
          : currency.is_separate_store
            ? translate('go_to_store_html', { country: currency.country })
            : `${currency.country} (${currency.currency_code})`
        }
        </option>`;
    });

    modal.innerHTML = `
    <div
      role="dialog"
      aria-label="Currency selector"
      aria-modal="true"
      tabindex="-1"
      class="!tw-relative !tw-m-0 !tw-flex tw-flex-col !tw-items-start !tw-p-[30px] modal-header"
      style="background-color: rgba(var(--color-secondary), 1)!important;"
    >
      <div class="tw-flex tw-w-full tw-justify-between tw-items-center">
        <h4 class="tw-m-0">Select your currency</h4>
        <button
          id="ModalClose-currency-popup"
          type="button"
          aria-label="Close"
          class="!tw-translate-x-0 !tw-border-none product-popup-modal__toggle cta tw-bg-transparent"
          onclick="sessionStorage.setItem('currencyModalClosed', 'true')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            class="icon icon-close"
            fill="none"
            viewBox="0 0 18 17"
          >
            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor" />
          </svg>
        </button>
      </div>

      <div class="tw-flex tw-relative tw-font-secondary tw-text-body-2 tw-pb-3 tw-border-brand-3 tw-border-b tw-w-full tw-mt-10">
        <select id="currency-select" class="tw-appearance-none tw-bg-transparent tw-border-transparent tw-w-full tw-rounded">
          ${optionsHtml}
        </select>
        <div class="tw-pointer-events-none tw-absolute tw-right-0">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path d="M5.90625 8.82642L10.5 13.4202L15.0938 8.82642" stroke="#817E74" stroke-width="1.3125"/>
          </svg>
        </div>
      </div>

      <div class="tw-mt-14 tw-flex tw-gap-4 tw-w-full tw-justify-center">
        <button class="tw-text-body-3 cta cta_secondary tw-w-full tw-border tw-py-6" id="currency-popup-accept">
          ${translate('accept')}
        </button>
      </div>
    </div>
  `;
    document.body.appendChild(modal);

    if (typeof modal.show === 'function') {
      modal.show();
    } else {
      modal.setAttribute('open', '');
    }


    const closeBtn = modal.querySelector('#ModalClose-currency-popup');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (typeof modal.hide === 'function') {
          modal.hide();
        } else {
          modal.removeAttribute('open');
        }
        setTimeout(() => modal.remove(), 300);
      });
    }

    const acceptBtn = modal.querySelector('#currency-popup-accept');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        const select = modal.querySelector('#currency-select');
        const selectedOption = select.options[select.selectedIndex];
        const isSeparateStore = selectedOption.dataset.separateStore === 'true';
        sessionStorage.setItem('currencyModalClosed', 'true');

        if (isSeparateStore && selectedOption.dataset.storeUrl) {
          window.location.href = selectedOption.dataset.storeUrl;
        } else {
          const marketId = selectedOption.dataset.marketId || false;

          // Try to submit the footer localization form to switch country (and currency)
          const footerCountryForm = document.querySelector('#FooterCountryForm');
          if (footerCountryForm && marketId) {
            const input = footerCountryForm.querySelector('input[name="country_code"]');
            if (input) {
              input.value = marketId;
              footerCountryForm.submit();
            }
          }

          if (typeof modal.hide === 'function') {
            modal.hide();
          } else {
            modal.removeAttribute('open');
          }
          setTimeout(() => modal.remove(), 300);
        }
      });
    }
  }

  showCurrencyPopup();

  function handleSelectChange(e) {
    const select = e.target;
    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;
    const isSeparate = selectedOption.getAttribute('data-separate-store') === 'true';
    if (isSeparate) {
      const storeUrl = selectedOption.getAttribute('data-store-url');
      if (storeUrl) window.location.href = storeUrl;
    }
  }

  function attachListeners() {
    // Close button click handler
    const closeButton = document.getElementById('ModalClose-currency-popup');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        sessionStorage.setItem('currencyModalClosed', 'true');
      });
    }

    const select = document.getElementById('store-currency-select');
    if (select) {
      select.addEventListener('change', handleSelectChange);
    }
  }

  function detectAndSuggestStore() {
    fetch('https://ipapi.co/json/')
      .then(resp => resp.json())
      .then(data => {

        const userCountry = data.country_code;
        const metaobjects = getCurrencyMetaobjects();
        const currentHost = window.location.hostname;
        for (const obj of metaobjects) {
          if (obj.is_separate_store && userCountry === obj.country) {
            if (getHostname(obj.store_url) !== currentHost) {
              showCurrencyPopup();
              break;
            }
          }
        }
      })
      .catch(() => {
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    attachListeners();
    if (window.NovicellStoreSelectorShowPopup) {
      detectAndSuggestStore();
    }
  });
})();
